import React from 'react'
import PropTypes from 'prop-types'
import {
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
  withStyles,
} from '@material-ui/core'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import AddButton from '../../common/AddButton'
import DeleteButton from '../../common/DeleteButton'

import {followUpQuestionTypeOptions} from '../../constants/NewTest'

import styles from '../styles/TestSetup.styles'

const SelectIcon = withStyles(theme => ({
  root: {
    marginRight: theme.spacing.unit / 2,
    color: theme.palette.grey[800],
  },
}))(ExpandMoreIcon)

const FollowUpQuestion = ({
  classes,
  followUp,
  disableInputs,
  addFollowUp,
  removeFollowUp,
  setFollowUpType,
  setFollowUpQuestion,
  followUpError,
  validateFields,
  currentQuestion,
}) => {
  if (!followUp) {
    if (disableInputs) {
      return null
    }

    return (
      <Grid container style={{alignItems: 'center', marginTop: 16}}>
        <AddButton onClick={addFollowUp} />
        <Typography>Add Follow-Up Question</Typography>
      </Grid>
    )
  }

  return (
    <>
      <Grid container style={{alignItems: 'center', marginTop: 16}}>
        <Typography variant="h6" className={classes.sectionTitle} style={{width: 'max-content'}}>
          Follow-Up Question
        </Typography>
        {!disableInputs && <DeleteButton onClick={removeFollowUp} />}
      </Grid>

      <Typography
        variant="body1"
        className={classes.sectionSubtitle}
        style={{width: 'max-content'}}
      >
        Question Type
      </Typography>
      <Select
        style={{overflow: 'initial'}}
        className={classes.selectRoot}
        classes={{
          icon: `${classes.selectIcon} ${disableInputs ? classes.disabledIcon : ''}`,
          selectMenu: classes.selectMenu,
        }}
        value={followUp.choiceType}
        variant="outlined"
        IconComponent={SelectIcon}
        onChange={({target}) => {
          setFollowUpType(target.value)
        }}
        input={<OutlinedInput labelWidth={0} classes={{notchedOutline: classes.notchedOutline}} />}
        disabled={disableInputs}
      >
        {followUpQuestionTypeOptions.map(({value, label}) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>

      <TextField
        value={followUp.question}
        onChange={({target}) => {
          setFollowUpQuestion(target.value.trimStart())
          validateFields(currentQuestion)
        }}
        variant="outlined"
        className={classes.nameInput}
        InputProps={{
          classes: {
            root: classes.nameInputOutline,
            notchedOutline: followUpError ? classes.errorOutline : classes.notchedOutline,
          },
          onBlur: () => {
            setFollowUpQuestion(followUp.question.trim())
            validateFields(currentQuestion)
          },
          readOnly: disableInputs,
        }}
        placeholder="Type your follow-up question"
        helperText={followUpError}
        FormHelperTextProps={{
          className: classes.inputErrorText,
          errormessage: 'true',
        }}
        multiline
        disabled={disableInputs}
      />
    </>
  )
}

FollowUpQuestion.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  followUp: PropTypes.shape({
    choiceType: PropTypes.number,
    question: PropTypes.string,
  }),
  disableInputs: PropTypes.bool.isRequired,
  addFollowUp: PropTypes.func.isRequired,
  removeFollowUp: PropTypes.func.isRequired,
  setFollowUpType: PropTypes.func.isRequired,
  setFollowUpQuestion: PropTypes.func.isRequired,
  followUpError: PropTypes.string,
  validateFields: PropTypes.func.isRequired,
  currentQuestion: PropTypes.number.isRequired,
}

FollowUpQuestion.defaultProps = {
  followUp: null,
  followUpError: '',
}

export default withStyles(styles)(FollowUpQuestion)
